import { AuthService } from './services/auth'
import { AccountFetchingError, NotLoggedInError } from '@/utils/exceptions'
import Vue, { VNode } from 'vue'
//@ts-ignore
import App from './App'
import router from '@/router/router'
import store from '@/store/store'
import '@/components'
import '@/filters'
import '@/directives'
import { Constants } from './services/constants'
import { SentryPlugin, vuetify } from './plugins'
import './services/AmplitudeService'
import { UserTypeService } from './services/UserTypeService'
import './assets/styles.scss'
import { AuthFlowHelper } from './utils'
import { LoginError } from '@/views/Error/LoginError/LoginError'
import 'core-js/stable'
import GenericError from './views/Error/GenericError/GenericError'

Vue.prototype.$CONSTANTS = Constants
Vue.config.productionTip = import.meta.env.DEV

console.log(`App Version: ${__VERSION_TAG__} ${__VERSION_HASH__} in ${import.meta.env.MODE}`)

// Initialize Sentry early for error reporting
if (!import.meta.env.DEV) {
	SentryPlugin.init()
}

async function initializeServices() {
	// User type service should be initialized before auth flows
	await UserTypeService.init()
	await AuthService.init()
}

initializeServices()
	.then(async () => {
		// Initialize user context using the appropriate auth service
		await AuthService.initializeUserContext()
		const user = await AuthService.getUser()

		// Set user in Sentry after authentication
		if (user) {
			SentryPlugin.setUser(user)
		}

		await store.dispatch('getUserDespachante')
		await store.dispatch('getLastCompletedClosing')

		var app = new Vue({
			router,
			store,
			vuetify,
			render: (h): VNode => h(App)
		}).$mount('#app')

		var isNewAuthFlowEnabled = await AuthFlowHelper.isNewAuthFlowEnabled()

		if (isNewAuthFlowEnabled) {
			await store.dispatch('setUserAccount')
		}
	})
	.catch((error) => {
		var errorScreen = GenericError

		if (error instanceof NotLoggedInError) {
			return
		}

		// Handle redirect scenarios - don't show error page when redirect is initiated
		if (error instanceof AccountFetchingError) {
			errorScreen = LoginError
			console.log('Main: Account fetching failed, redirecting to error page')
		}

		console.error('Application failed to start:', error)
		SentryPlugin.sendException(error, {
			tags: {
				component: 'main',
				stage: 'app_startup'
			},
			contexts: {
				app: {
					version: `${__VERSION_TAG__} ${__VERSION_HASH__}`,
					environment: import.meta.env.MODE
				}
			}
		})

		// Create a minimal Vue app to render the error component
		const errorApp = new Vue({
			vuetify,
			render: (h): VNode => h(errorScreen)
		}).$mount('#app')
	})
